import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { emailApi } from '../api/emailApi';

/** Org-wide email autopilot master switch (spec §5). Org-scoped, not per-thread. */
export function useEmailAutopilot() {
  return useQuery({
    queryKey: keys.email.autopilot,
    queryFn: ({ signal }) => emailApi.getAutopilot({ signal }),
    staleTime: 60_000,
  });
}

export function useSetEmailAutopilot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (enabled: boolean) => emailApi.setAutopilot(enabled),
    onSuccess: (data) => {
      queryClient.setQueryData(keys.email.autopilot, data);
      void queryClient.invalidateQueries({ queryKey: keys.email.autopilot });
    },
  });
}
